import axios from 'axios';

// Quản lý access JWT (Bearer) cho admin web.
// BE phát token trong response login (LoginUserModelResponse.token, 7 ngày).
// FE lưu localStorage và gắn vào header Authorization mặc định của axios.

const TOKEN_KEY = "token";

export function applyAuthToken(token) {
  if (token) {
    window.localStorage.setItem(TOKEN_KEY, token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  }
}

export function clearAuthToken() {
  window.localStorage.removeItem(TOKEN_KEY);
  delete axios.defaults.headers.common['Authorization'];
}

// Gọi khi khởi động app: đọc token đã lưu và gắn lại header mặc định.
export function initAuthToken() {
  const token = window.localStorage.getItem(TOKEN_KEY);
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  }
}

// Chỉ bắt 401 (token hết hạn/sai) để xóa token + metadata login và yêu cầu đăng nhập lại.
// KHÔNG xóa token khi 403: 403 = token vẫn hợp lệ nhưng thiếu quyền cho riêng endpoint đó,
// không được logout cả phiên. Không refresh (cơ chế pure-JWT, không có refresh token).
export function setupAuthInterceptor() {
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error.response && error.response.status;
      if (status === 401 && window.localStorage.getItem(TOKEN_KEY)) {
        clearAuthToken();
        window.localStorage.removeItem("login");
        window.localStorage.removeItem("userId");
        window.localStorage.removeItem("profileImageLink");
        window.localStorage.removeItem("name");
      }
      return Promise.reject(error);
    }
  );
}
